import type { TaxInformation } from "libs/codegen/property-onboarding";
import { useEffect } from "react";
import { type useFormContext, useWatch } from "react-hook-form";
import type { BulkPropertyFormData } from "../BulkPropertyFormData";

export interface TaxFieldsSyncerProps {
    primaryIndex: number;
    syncTargetIndices: number[];
    setValue: ReturnType<typeof useFormContext<BulkPropertyFormData>>["setValue"];
}

/**
 * Invisible component that watches the primary property's tax information
 * and syncs it to all other properties with the same country
 */
export const TaxFieldsSyncer = ({ primaryIndex, syncTargetIndices, setValue }: TaxFieldsSyncerProps) => {
    const taxInformation = useWatch<BulkPropertyFormData>({
        name: `propertyDataList.${primaryIndex}.taxInformation`,
    }) as TaxInformation | undefined;

    useEffect(() => {
        if (taxInformation === undefined) return;

        // Sync tax information to all other properties with the same country
        for (const targetIndex of syncTargetIndices) {
            setValue(`propertyDataList.${targetIndex}.taxInformation`, taxInformation, {
                shouldValidate: false,
                shouldDirty: false,
            });
        }
    }, [taxInformation, syncTargetIndices, setValue]);

    return null;
};
